/**
 * WordPress Dependencies
 */
import { __ } from "@wordpress/i18n";
import {
	PanelBody,
	BaseControl,
	__experimentalUnitControl as UnitControl,
	ToggleControl,
	TextControl,
} from "@wordpress/components";
import { InspectorControls } from "@wordpress/block-editor";
import { useDispatch, useSelect } from "@wordpress/data";
import { get } from "lodash";

import Templates from "./templates";

function CustomInspectorControls(props) {
	const { attributes, setAttributes } = props;

	const {
		ghubQcHeight,
		ghubQcGap,
		ghubQcStackOnMobile,
		className,
		ghubQcPostRel,
		ghubQcIsPostLink,
		ghubQcPostLinkTarget,
	} = attributes;

	const attr = {
		ghubQcHeight,
		ghubQcGap,
		ghubQcStackOnMobile,
	};

	const { replaceInnerBlocks, updateBlockAttributes } = useDispatch(
		"core/block-editor"
	);
	const block = useSelect((select) =>
		select("core/block-editor").getBlock(props.clientId)
	);

	const handleLayout = (layout) => {
		let createdBlock = wp.blocks.createBlocksFromInnerBlocksTemplate(
			layout.template
		);

		updateBlockAttributes(props.clientId, {
			...createdBlock[0].attributes,
			...attr,
		});
		const oldInnerBlocks = block.innerBlocks.innerBlocks;
		const newPostTemplate = createdBlock[0].innerBlocks;

		replaceInnerBlocks(newPostTemplate.clientId, oldInnerBlocks);

		replaceInnerBlocks(props.clientId, createdBlock[0].innerBlocks);
	};

	return (
		<InspectorControls>
			<PanelBody
				initialOpen={false}
				title={__("Pro Post Grid", "gutenberg-pro-ext")}
			>
				<BaseControl label={__("Select Layout", "gutenberg-pro-ext")}>
					<div className="ghub-qc-grid">
						{Templates.map((template, index) => {
							const templateClass = get(
								template,
								"template[0][1].className",
								""
							);

							const getFirstClassName = className.match(/\S+/)[0];

							return (
								<img
									className={
										templateClass === getFirstClassName
											? "ghub-collage-placeholder-active"
											: ""
									}
									src={template.icon}
									onClick={() => handleLayout(template)}
								/>
							);
						})}
					</div>
				</BaseControl>

				<UnitControl
					label={__("Height", "gutenberg-pro-ext")}
					value={ghubQcHeight}
					onChange={(newValue) => setAttributes({ ghubQcHeight: newValue })}
				/>

				<UnitControl
					label={__("Gap", "gutenberg-pro-ext")}
					value={ghubQcGap}
					onChange={(newValue) => setAttributes({ ghubQcGap: newValue })}
				/>

				<ToggleControl
					label={__("Stack On Mobile", "gutenberg-pro-ext")}
					checked={ghubQcStackOnMobile}
					onChange={() => {
						setAttributes({ ghubQcStackOnMobile: !ghubQcStackOnMobile });
					}}
				/>
				<ToggleControl
					__nextHasNoMarginBottom
					label={__("Make Post a link")}
					onChange={() =>
						setAttributes({ ghubQcIsPostLink: !ghubQcIsPostLink })
					}
					checked={ghubQcIsPostLink}
				/>
				{ghubQcIsPostLink && (
					<>
						<ToggleControl
							__nextHasNoMarginBottom
							label={__("Open in new tab")}
							onChange={(value) =>
								setAttributes({
									ghubQcPostLinkTarget: value ? "_blank" : "_self",
								})
							}
							checked={ghubQcPostLinkTarget === "_blank"}
						/>
						<TextControl
							__nextHasNoMarginBottom
							label={__("Link rel")}
							value={ghubQcPostRel}
							onChange={(newRel) => setAttributes({ ghubQcPostRel: newRel })}
						/>
					</>
				)}
			</PanelBody>
		</InspectorControls>
	);
}

export default CustomInspectorControls;
